const labelStyles = (labelOffset, maxWidthInPercentage) => ({
  "&.MuiFormControl-root .MuiInputLabel-root": {
    display: "flex",
    flexDirection: "row-reverse",
    "&:before": {
      display: "none"
    },
    ...labelOffset && {
      transform: `translate(${labelOffset}px, 16px) scale(1)`
    },
    ...maxWidthInPercentage && { maxWidth: `${maxWidthInPercentage}%` },
    "& .MuiFormLabel-asterisk": {
      color: "error.800",
      marginRight: "2px",
      display: "block"
    },
    "&.MuiInputLabel-shrink": {
      ...labelOffset && {
        transform: `translate(${labelOffset}px, 7px) scale(0.75)`
      },
      ...maxWidthInPercentage && {
        maxWidth: `${maxWidthInPercentage * 1.33}%`
      }
    }
  }
});
const inputStyles = {
  "&& .MuiInputBase-root.MuiInputBase-adornedStart.MuiFilledInput-root, .MuiInputBase-fullWidth.MuiInputBase-root.MuiInputBase-adornedStart.MuiFilledInput-root": {
    paddingTop: 0,
    paddingLeft: "12px",
    paddingBottom: 0
  },
  "&& .MuiFilledInput-input.MuiInputBase-inputAdornedStart": {
    paddingTop: "25px",
    paddingLeft: "16px",
    paddingBottom: "8px",
    textAlign: "left"
  }
};
export {
  inputStyles,
  labelStyles
};
